import PcPromoBanner from '../components/PcPromoBanner/index.vue';


export default {
  PcPromoBanner,
};
